import { ColumnSizing } from '../tables-context';
import { MRT_ColumnDef } from 'material-react-table';
import { TableCell } from '../../../components/table/TableCell';
import React from 'react';
import { Link } from 'react-router-dom';
import { DisputeTableAccessorKey, getAmount, getBinLast4, getTableDate } from '../disputes/disputes-data';
import { IDisputeQueueItem } from '../disputes/disputes-queue';
import { CopyComponent } from '../../../components/CopyComponent';
import { DateComponent } from '../../../components/DateComponent';
import { ITransactionsData } from '../../payments/payments-interfaces-helper';
import { RELATED_ENTITY_TYPE, RelatedEntityNameLink } from '../../../components/merchants/RelatedEntityNameLink';

export enum TransactionsTableAccessorKey {
	transactionId = 'id',
	date = 'createdOn',
	orderRef = 'orderId',
	type = 'type',
	source = 'source',
	provider = 'providerName',
	statusCode = 'responseCode',
	status = 'status',
	amount = 'amount',
	bin = 'bin',
	last4 = 'last4',
	externalReferenceId = 'externalReferenceID',
	authorizationID = 'authorizationID',
	merchantName = 'merchantName',
	gateway = 'gateway',
	dynamicDescriptor = 'dynamicDescriptor',
}

export const defaultTransactionColumnSizing: ColumnSizing = {
	[TransactionsTableAccessorKey.transactionId]: 120,
	[TransactionsTableAccessorKey.date]: 50,
	[TransactionsTableAccessorKey.orderRef]: 120,
	[TransactionsTableAccessorKey.externalReferenceId]: 120,
	[TransactionsTableAccessorKey.authorizationID]: 100,
	[TransactionsTableAccessorKey.type]: 60,
	[TransactionsTableAccessorKey.source]: 50,
	[TransactionsTableAccessorKey.provider]: 80,
	[TransactionsTableAccessorKey.statusCode]: 50,
	[TransactionsTableAccessorKey.status]: 50,
	[TransactionsTableAccessorKey.amount]: 50,
	[TransactionsTableAccessorKey.bin]: 50,
	[TransactionsTableAccessorKey.merchantName]: 100,
	[TransactionsTableAccessorKey.gateway]: 70,
	[TransactionsTableAccessorKey.dynamicDescriptor]: 100,
};

export const defaultTransactionsColumns: MRT_ColumnDef<ITransactionsData>[] = [
	{
		accessorKey: TransactionsTableAccessorKey.date,
		header: 'Date',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Date</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				{renderedCellValue
					? <DateComponent
						value={renderedCellValue}
						isTime
					/>
					: '-'
				}
			</TableCell>
		)
	},
	{
		accessorKey: TransactionsTableAccessorKey.orderRef,
		header: 'Order ref',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Order ref</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black fw-bolder fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				<CopyComponent value={renderedCellValue} title="Order Id"/>
				<Link
					to={`/orders/${renderedCellValue}`}
					className="text-black fc-text-overflow ms-2"
					target="_blank"
				>
					{renderedCellValue}
				</Link>
			</TableCell>
		)
	},
	{
		accessorKey: TransactionsTableAccessorKey.externalReferenceId,
		header: 'External reference id',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">External reference id</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				{renderedCellValue ? renderedCellValue : '-'}
			</TableCell>
		)
	},
	{
		accessorKey: TransactionsTableAccessorKey.type,
		header: 'Type',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Type</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				{renderedCellValue}
			</TableCell>
		)
	},
	// {
	// 	accessorKey: TransactionsTableAccessorKey.source,
	// 	header: 'Source',
	// 	enableSorting: false,
	// 	Header: <span className="text-muted fw-bolder main-font-family">Source</span>,
	// 	Cell: ({ renderedCellValue, table }: any): JSX.Element => (
	// 		<TableCell
	// 			additionalClass="main-font-family text-black fs-7"
	// 			density={table?.options?.state?.density}
	// 			isTextOverflow={true}
	// 		>
	// 			{renderedCellValue ? renderedCellValue : '-'}
	// 		</TableCell>
	// 	)
	// },
	{
		accessorKey: TransactionsTableAccessorKey.provider,
		header: 'Provider',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Provider</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				{renderedCellValue}
			</TableCell>
		)
	},
	{
		accessorKey: TransactionsTableAccessorKey.statusCode,
		header: 'Status code',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Status code</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				{renderedCellValue}
			</TableCell>
		)
	},
	{
		accessorKey: TransactionsTableAccessorKey.status,
		header: 'Status',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Status</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				{renderedCellValue ? renderedCellValue : '-'}
			</TableCell>
		)
	},
	{
		accessorKey: TransactionsTableAccessorKey.amount,
		header: 'Amount',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Amount</span>,
		Cell: ({ renderedCellValue, table, row }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				{getAmount(renderedCellValue, row.original.currency)}
			</TableCell>
		)
	},
	{
		accessorKey: TransactionsTableAccessorKey.bin,
		header: 'Bin / Last 4',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Bin / Last 4</span>,
		Cell: ({ renderedCellValue, table, row }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				{getBinLast4(renderedCellValue, row.original.last4)}
			</TableCell>
		)
	},
];

export const defaultDisputeTransactionsColumns: MRT_ColumnDef<ITransactionsData>[] = [
	// {
	// 	accessorKey: TransactionsTableAccessorKey.transactionId,
	// 	header: 'Transaction Id',
	// 	enableSorting: false,
	// 	Header: <span className="text-muted fw-bolder main-font-family">Transaction Id</span>,
	// 	Cell: ({ renderedCellValue, table }: any): JSX.Element => (
	// 		<TableCell
	// 			additionalClass="main-font-family text-black fw-bolder fs-7"
	// 			density={table?.options?.state?.density}
	// 			isTextOverflow={true}
	// 		>
	// 			{renderedCellValue}
	// 		</TableCell>
	// 	)
	// },
	{
		accessorKey: TransactionsTableAccessorKey.date,
		header: 'Date',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Date</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				{renderedCellValue ? getTableDate(renderedCellValue, true) : '-'}
			</TableCell>
		)
	},
	{
		accessorKey: TransactionsTableAccessorKey.orderRef,
		header: 'Order ref',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Order ref</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black fw-bolder fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				<CopyComponent value={renderedCellValue} title="Order Id"/>
				<Link
					to={`/orders/${renderedCellValue}`}
					className="text-black fc-text-overflow ms-2"
					target="_blank"
				>
					{renderedCellValue}
				</Link>
			</TableCell>
		)
	},
	{
		accessorKey: TransactionsTableAccessorKey.externalReferenceId,
		header: 'External reference id',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">External reference id</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				{renderedCellValue ? renderedCellValue : '-'}
			</TableCell>
		)
	},
	{
		accessorKey: DisputeTableAccessorKey.authorizationID,
		header: 'Dispute type',
		enableSorting: false,
		Header: <span className="margin-left-0 text-muted fw-bolder main-font-family">Authorization Id</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				<div className="fc-text-overflow">
					{renderedCellValue ? renderedCellValue : '-'}
				</div>
			</TableCell>
		),
	},
	{
		accessorKey: TransactionsTableAccessorKey.merchantName,
		header: 'Merchant name',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Merchant name</span>,
		Cell: ({ renderedCellValue, row, table }: any): JSX.Element => (

			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				<RelatedEntityNameLink name={renderedCellValue} id={row?.original?.merchantId}
									   type={RELATED_ENTITY_TYPE.MERCHANT} />
			</ TableCell>
		)
	},
	{
		accessorKey: TransactionsTableAccessorKey.gateway,
		header: 'Type',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Gateway</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				{renderedCellValue}
			</TableCell>
		)
	},
	{
		accessorKey: TransactionsTableAccessorKey.dynamicDescriptor,
		header: 'Type',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Descriptor</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				{renderedCellValue}
			</TableCell>
		)
	},
	{
		accessorKey: TransactionsTableAccessorKey.type,
		header: 'Type',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Type</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				{renderedCellValue}
			</TableCell>
		)
	},
	// {
	// 	accessorKey: TransactionsTableAccessorKey.source,
	// 	header: 'Source',
	// 	enableSorting: false,
	// 	Header: <span className="text-muted fw-bolder main-font-family">Source</span>,
	// 	Cell: ({ renderedCellValue, table }: any): JSX.Element => (
	// 		<TableCell
	// 			additionalClass="main-font-family text-black fs-7"
	// 			density={table?.options?.state?.density}
	// 			isTextOverflow={true}
	// 		>
	// 			{renderedCellValue ? renderedCellValue : '-'}
	// 		</TableCell>
	// 	)
	// },
	// {
	// 	accessorKey: TransactionsTableAccessorKey.provider,
	// 	header: 'Provider',
	// 	enableSorting: false,
	// 	Header: <span className="text-muted fw-bolder main-font-family">Provider</span>,
	// 	Cell: ({ renderedCellValue, table }: any): JSX.Element => (
	// 		<TableCell
	// 			additionalClass="main-font-family text-black fs-7"
	// 			density={table?.options?.state?.density}
	// 			isTextOverflow={true}
	// 		>
	// 			{renderedCellValue}
	// 		</TableCell>
	// 	)
	// },
	// {
	// 	accessorKey: TransactionsTableAccessorKey.statusCode,
	// 	header: 'Status code',
	// 	enableSorting: false,
	// 	Header: <span className="text-muted fw-bolder main-font-family">Status code</span>,
	// 	Cell: ({ renderedCellValue, table }: any): JSX.Element => (
	// 		<TableCell
	// 			additionalClass="main-font-family text-black fs-7"
	// 			density={table?.options?.state?.density}
	// 			isTextOverflow={true}
	// 		>
	// 			{renderedCellValue}
	// 		</TableCell>
	// 	)
	// },
	{
		accessorKey: TransactionsTableAccessorKey.status,
		header: 'Status',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Status</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				{renderedCellValue ? renderedCellValue : '-'}
			</TableCell>
		)
	},
	{
		accessorKey: TransactionsTableAccessorKey.amount,
		header: 'Amount',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Amount</span>,
		Cell: ({ renderedCellValue, table, row }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				{getAmount(renderedCellValue, row.original.currency)}
			</TableCell>
		)
	},
	{
		accessorKey: TransactionsTableAccessorKey.bin,
		header: 'Bin / Last 4',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Bin / Last 4</span>,
		Cell: ({ renderedCellValue, table, row }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				{getBinLast4(renderedCellValue, row.original.last4)}
			</TableCell>
		)
	},
];

interface IDisputeInfoFields {
	key: string;
	title: string;
	value: string | number | Date | boolean | null;
	tablet: number;
	desktop: number;
}

export const getDisputeInformationFields = (array: IDisputeQueueItem): IDisputeInfoFields[] => ([
	{
		key: 'createdOn',
		title: 'Created On',
		value: array?.createdOn,
		tablet: 1,
		desktop: 1,
	},
	{
		key: 'authorizationDate',
		title: 'Authorization Date',
		value: array?.authorizationDate || array?.transactionDate,
		tablet: 1,
		desktop: 1,
	},
	{
		key: 'requestDate',
		title: 'Request Date',
		value: array?.requestDate,
		tablet: 1,
		desktop: 1,
	},
	{
		key: 'disputeType',
		title: 'Dispute Type',
		value: array?.disputeType,
		tablet: 1,
		desktop: 1,
	},
	{
		key: 'authorizationId',
		title: 'Authorization Id',
		value: array?.authorizationId,
		tablet: 1,
		desktop: 1,
	},
	{
		key: 'stage',
		title: 'Stage',
		value: array?.stage,
		tablet: 1,
		desktop: 1,
	},
	{
		key: 'providerName',
		title: 'Source',
		value: array?.providerName,
		tablet: 1,
		desktop: 2,
	},
	{
		key: 'descriptor',
		title: 'Descriptor',
		value: array?.descriptor,
		tablet: 1,
		desktop: 2,
	},
	{
		key: 'amount',
		title: 'Amount',
		value: array?.amount,
		tablet: 1,
		desktop: 2,
	},
	{
		key: 'cardBrand',
		title: 'Card',
		value: array?.cardBrand,
		tablet: 1,
		desktop: 2,
	},
	{
		key: 'arn',
		title: 'ARN',
		value: array?.arn,
		tablet: 2,
		desktop: 2,
	},
	{
		key: 'isWebhook',
		title: 'Is Webhook',
		value: array?.isWebhook,
		tablet: 2,
		desktop: 2,
	},
	{
		key: 'invoiceNumber',
		title: 'Invoice Number',
		value: array?.invoiceNumber,
		tablet: 2,
		desktop: 3,
	},
	{
		key: 'chargebackWinLoss',
		title: 'Win/Loss',
		value: array?.chargebackWinLoss,
		tablet: 2,
		desktop: 3,
	},
	{
		key: 'externalReferenceID',
		title: 'External Reference ID',
		value: array?.externalReferenceID,
		tablet: 2,
		desktop: 3,
	},
	{
		key: 'orderId',
		title: 'Order ID',
		value: array?.orderId,
		tablet: 2,
		desktop: 3,
	},
	{
		key: 'disputeReasonCode',
		title: 'Reason',
		value: array?.disputeReasonCode,
		tablet: 2,
		desktop: 3,
	},
	{
		key: 'issuer',
		title: 'Issuer',
		value: array?.issuer,
		tablet: 2,
		desktop: 3,
	},
	// {
	// 	key: 'is3D',
	// 	title: 'Is 3D',
	// 	value: array?.is3D,
	// 	tablet: 2,
	// 	desktop: 3,
	// },
]);
